import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Protegge le route private: se non autenticato reindirizza al login,
 * conservando la destinazione originale.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <main className="grid min-h-screen place-items-center">
        <p role="status">Caricamento in corso…</p>
      </main>
    );
  }

  if (!user) {
    return <Navigate to="/accedi" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
